import { FIELD_ASYNC_ACTIONS, } from '@wix/form-fields/async-actions';
import { FORM_ASYNC_ACTIONS } from '../../form-actions';
const getFieldTypes = (forms) => {
    return forms
        .filter((form) => form !== undefined)
        .map((form) => form.fields)
        .flat()
        .reduce((result, field) => {
        var _a;
        if (result.find((fieldType) => { var _a; return fieldType === ((_a = field === null || field === void 0 ? void 0 : field.view) === null || _a === void 0 ? void 0 : _a.fieldType); })) {
            return result;
        }
        result.push((_a = field === null || field === void 0 ? void 0 : field.view) === null || _a === void 0 ? void 0 : _a.fieldType);
        return result;
    }, []);
};
const bindArguments = (actions, args) => {
    return Object.keys(actions).reduce((result, actionName) => {
        var _a;
        result[actionName] = (_a = actions[actionName]) === null || _a === void 0 ? void 0 : _a.call(actions, args);
        return result;
    }, {});
};
export const createActions = (forms, { httpClient, requestCaptcha, fedopsLogger }) => {
    const fieldTypes = getFieldTypes(Object.values(forms));
    const formActions = bindArguments(FORM_ASYNC_ACTIONS, {
        httpClient,
        requestCaptcha,
        fedopsLogger,
    });
    const fieldActions = fieldTypes.reduce((result, type) => {
        if (type in FIELD_ASYNC_ACTIONS) {
            const actions = FIELD_ASYNC_ACTIONS[type];
            const actionsWithProps = bindArguments(actions, {
                httpClient,
                requestCaptcha,
                fedopsLogger,
            });
            result = Object.assign(Object.assign({}, result), actionsWithProps);
        }
        return result;
    }, {});
    return Object.assign(Object.assign({}, formActions), fieldActions);
};
//# sourceMappingURL=create-actions.js.map